import api from './api';
import authHeader from './auth-header';

class GitService {
    getGitActivity(limit, after) {
        const params = new URLSearchParams();
        if (limit) {
            params.append('limit', limit.toString());
        }
        if (after) {
            params.append('after', after.toString());
        }
        const queryString = params.toString();
        const url = `/chat/git-activity${queryString ? `?${queryString}` : ''}`;
        return api.get(url, { headers: authHeader() });
    }
}

const gitService = new GitService();
export default gitService;





